<template>
  <b-container>
    <div class="b-main-content">
      <b-card class="basic-box-shadow" title="Gestione API">
        <div v-if="isBusy">
          <div class="text-center text-secondary my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </div>

        <div v-if="!isBusy" class="mt-2">
          <div v-show="accessKey">
            <p>
              <b>Data Lake API Endpoint:</b>
              {{ hostName }}
            </p>
            <p>
              <b>Data Lake Access Key:</b>
              {{ accessKey }}
            </p>
            <p>
              <b>Data Lake Secret Access Key:</b>&nbsp;
              <b-button
                v-show="!generating"
                @click="generateSecretAccessKey()"
                variant="outline-primary"
                size="sm"
                class="ml-auto"
              >Genera chiave</b-button>

              <b-button size="sm" v-show="generating" variant="outline-primary" disabled>
                <b-spinner style="width: 1.25rem; height: 1.25rem;" label="Loading..."></b-spinner>
                <span class="sr-only">Loading...</span>
              </b-button>
            </p>
          </div>

          <div v-show="!accessKey">
            <p>
              Non disponi ancora di una chiave di accesso...
              <b-button
                v-show="!generating"
                @click="retrieveUserData()"
                variant="outline-secondary"
                size="sm"
              >Riprova</b-button>
              <b-button v-show="generating" size="sm" variant="outline-secondary" disabled>
                <b-spinner style="width: 1.25rem; height: 1.25rem;" label="Loading..."></b-spinner>
                <span class="sr-only">Loading...</span>
              </b-button>
            </p>
          </div>
        </div>
      </b-card>
    </div>

    <div>
      <b-modal id="modal" ref="modal" title="Secret Access Key" ok-only>
        <div class="text-center">
          <img
            src="/datacatalog-simple/images/fogg-api.png"
            class="w-75 img-fluid"
            alt="illustration"
          />
        </div>
        <p class="my-4">
          <b>Secret Access Key:</b>
          {{ apiKey }}
        </p>
      </b-modal>
    </div>
  </b-container>
</template>

<script>
/*
  Page for managing the user's API keys
*/

import { mapState } from 'vuex'
import store from '@/store'

export default {
  data () {
    return {
      isBusy: true,
      generating: false
    }
  },
  async beforeMount () {
    // retrieve user's API informations
    await store.dispatch('auth/retrieveProfileHostname')
    await store.dispatch('auth/retrieveUserData')
    this.isBusy = false
  },
  computed: {
    ...mapState({
      hostName: state => state.auth.profileHostname,
      apiKey: state => state.auth.profileApiKey,
      accessKey: state => state.auth.userData.accesskey
    })
  },
  methods: {
    async generateSecretAccessKey () {
      this.generating = true
      // generate a new secret access key
      await store.dispatch('auth/retrieveProfileApiKey')
      // show a modal with the new key
      this.$refs.modal.show()
      this.generating = false
    },
    async retrieveUserData () {
      this.generating = true
      // refresh user data
      await store.dispatch('auth/retrieveUserData')
      this.generating = false
    }
  }
}
</script>
